import { useState } from "react";
import { motion, useScroll, useMotionValueEvent } from "framer-motion";
import { Globe } from "@/components/Globe";

const LINKS = [
  { href: "#manifest", label: "Manifest", testId: "nav-link-manifest" },
  { href: "#mission", label: "Mission", testId: "nav-link-mission" },
  { href: "#faq", label: "FAQ", testId: "nav-link-faq" },
];

export const Header = () => {
  const [compact, setCompact] = useState(false);
  const { scrollY } = useScroll();
  useMotionValueEvent(scrollY, "change", (v) => setCompact(v > 60));

  const go = (e, href) => {
    e.preventDefault();
    window.__lenis?.scrollTo(href, { offset: -64 });
  };

  return (
    <motion.header
      data-testid="site-header"
      className="fixed top-0 left-0 z-50 w-full border-b-2 border-[#f4f4f2] bg-[#0a0a0a]"
      animate={{ paddingTop: compact ? 10 : 20, paddingBottom: compact ? 10 : 20 }}
      transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
    >
      <div className="mx-auto flex max-w-[1100px] items-center justify-between px-6">
        <a
          href="#top"
          onClick={(e) => go(e, "#top")}
          className="flex items-center gap-3"
          data-testid="header-logo-link"
        >
          <motion.span
            animate={{ width: compact ? 24 : 34, height: compact ? 24 : 34 }}
            transition={{ duration: 0.35, ease: [0.16, 1, 0.3, 1] }}
            className="block text-[#f4f4f2]"
          >
            <Globe spin className="h-full w-full" />
          </motion.span>
          <span className="font-mono2 text-xs font-bold uppercase tracking-[0.18em] md:text-sm">
            Housegemacht
          </span>
        </a>
        <nav className="flex items-center gap-5 md:gap-8" data-testid="header-nav">
          {LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              onClick={(e) => go(e, l.href)}
              data-testid={l.testId}
              className="group relative hidden font-mono2 text-[11px] font-bold uppercase tracking-[0.16em] text-[#a8a8a4] transition-colors duration-200 hover:text-[#f4f4f2] md:block"
            >
              {l.label}
              <span className="absolute -bottom-1 left-0 h-[2px] w-0 bg-[#f4f4f2] transition-all duration-300 group-hover:w-full" />
            </a>
          ))}
          <a
            href="https://www.instagram.com/housegemachtt"
            target="_blank"
            rel="noopener noreferrer"
            data-testid="header-instagram-button"
            className="border-2 border-[#f4f4f2] px-3 py-1.5 font-mono2 text-[11px] font-bold uppercase tracking-[0.12em] transition-colors duration-200 hover:bg-[#f4f4f2] hover:text-[#0a0a0a] md:px-4 md:py-2"
          >
            Instagram
          </a>
        </nav>
      </div>
    </motion.header>
  );
};
